import { useLazyQuery } from '@apollo/client';
import { exportXlsModal } from 'motion-components';
import { gqlGetEdocs } from '../graphql';
import { buildWhereFromFilterValues } from './filters';
import { useState } from 'react';

// export columns for the route
export const exportColumns = (t) => {
  return [
    { fieldName: 'edocSeries.name', fieldTitle: t('Σειρά Αρίθμησης'), fieldType: 'TEXT' },
    { fieldName: 'edocNumber', fieldTitle: t('Κωδικός Εντύπου'), fieldType: 'TEXT' },

    { fieldName: 'jsonContentTitle', fieldTitle: t('Περιεχόμενο'), fieldType: 'TEXT' },
    { fieldName: 'firstDate', fieldTitle: t('Ημερ. Δημιουργίας'), fieldType: 'DATE' },
  ];
};

export async function handleExport(client, queryState: any, t): Promise<void> {
  function useGetQuery() {
    const [get, { loading }] = useLazyQuery(gqlGetEdocs, {
      onCompleted: transformData,
      fetchPolicy: 'network-only',
    });

    const [result, setResult] = useState<any>([get, { loading, data: undefined }]);

    function transformData(data) {
      const recs = data.getEdocs.data.map((v) => {
        const obj = JSON.parse(v.jsonContent);
        let jsonContentTitle = '';
        if (v.edocTypeId === 1 && obj?.collection) {
          jsonContentTitle = `${obj?.collection?.code}: ${obj?.collection['collectionpoint.name']}`;
        }
        return {
          ...v,
          jsonContentTitle: jsonContentTitle,
          isActiveText: v.isActive ? 'ΝΑΙ' : 'ΟΧΙ',
        };
      });

      const trsData = {
        getEdocs: {
          data: recs,
          recordCount: data?.getEdocs?.recordCount,
        },
      };

      setResult([get, { loading, data: trsData }]);
    }

    return result;
  }

  const filterVariables = {
    where: buildWhereFromFilterValues(queryState?.filterValues),
  };

  await exportXlsModal({
    apolloClient: client,
    exportFileName: t('Πρωτόκολλο'),
    getLazyQuery: useGetQuery,
    columnsDef: exportColumns(t),
    filterVariables: filterVariables,
  });
}

